import { NgModule } from '@angular/core';
import { RemoveSpacesPipe } from './remove-spaces.pipe';

@NgModule({
  declarations: [RemoveSpacesPipe],
  exports: [RemoveSpacesPipe]
})
export class RemoveSpacesPipeModule {}
